module.exports = __webpack_public_path__ + "static/img/gf4.48c492c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gf4.png
// module id = 8MBy
// module chunks = 1